<template>
    <app-ghost-mode>
        <!-- stage one of post aNewItem -->
        <div class="jumbotron screen-center p-5">
            <form enctype="multipart/form-data" class="account-photo-upload">
                <!-- stage heading -->
                <div class="row">
                    <div class="col-12 text-center">
                        <h4>Change {{kind}} photo</h4>
                    </div>
                </div>
                <div class="row">
                    <!-- preview images -->
                    <div v-if="previewArrCheck" class="col-12">
                        <div v-for="(x, i) in previewArrCheck" :key="i">
                            <app-image-cropper :kind="kind" :key="reloadKey" @closeCrop="closeCropPage" :src="x.path" class="mt-2 mb-5" />
                        </div>
                    </div>
                    <!-- select image -->
                    <div v-else class="col-12">
                        <div class="text-center text-muted">
                            <div class="my-3">
                                <label for="file-input" class="btn btn-secondary btn-sm">
                                    <i class="far fa-plus-square fa-xs"></i> select photo
                                </label>
                                <input @change="uploadProceed" type="file" accept="image/jpeg, image/png, image/gif" hidden id="file-input"/>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </app-ghost-mode>
</template>

<script>
import GhostMode from '@/components/general/shared/GhostMode.vue'
import ImageCropper from '@/components/user/shared/ImageCropper.vue'

export default {
    name: "ChangePhoto",
    props: ['kind'],
    data() {
        return {
            price: '',
            previewArr: [],
            photosArr: [],
            previewImg: '',
            reloadKey: 0
        }
    },
    methods: {
        uploadProceed(e) {
            // empty the arrays first
            this.photosArr = []
            this.previewArr = []
            let images = e.target.files
            for(let x=0; x < images.length; x++){
                let reader = new FileReader()
                reader.readAsDataURL(images[x])
                reader.onload = e => {
                    this.previewImg = e.target.result;
                    let previewObj = {
                        path: this.previewImg,
                        main: false
                    }
                    this.previewArr.push(previewObj)
                    let photoObj = {
                        path: images,
                        main: false
                    }
                    this.photosArr.push(photoObj)
                }   
            }
        },
        closeCropPage() {
            this.previewArr = []
            this.photosArr = []
            this.reloadKey += 1
        }
    },
    computed: {
        previewArrCheck() {
            if(this.previewArr.length > 0){
                return this.previewArr
            }
            return false
        }
    },
    components: {
        appGhostMode: GhostMode,
        appImageCropper: ImageCropper
    },
    mounted() {
        this.previewArr = []
    },
}
</script>